import React, { useEffect, useState } from "react";

import { formatLockInCountdownLabel } from "../utils/lockInDisplay";

/**
 * Re-renders periodically so the calendar-day countdown stays fresh without parent polling.
 */
export default function LockInCountdown({ unlockIso, className, style, variant = "inline" }) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = window.setInterval(() => setTick((n) => n + 1), 60000);
    return () => window.clearInterval(id);
  }, []);

  const label = formatLockInCountdownLabel(unlockIso);
  if (!label) return null;
  if (variant === "block") {
    return (
      <div className={className || "muted"} style={{ marginTop: 6, fontSize: 13, lineHeight: 1.45, ...style }}>
        {label}
      </div>
    );
  }
  return (
    <span className={className || "muted"} style={style}>
      {" "}
      · {label}
    </span>
  );
}
